module.exports = __webpack_public_path__ + "media/images/logo/logo_service-ab5c89098197c85d5009b04047cdd483.png";